// extracted by mini-css-extract-plugin
export default {"Feedback":"ForgotPassword_Feedback__1qdEt","ResetPasswordForm":"ForgotPassword_ResetPasswordForm__J5HfU"};